module.exports = __webpack_public_path__ + "img/supervision_960.22116415.webp";